export const UI_VERSION = 'v1.416.6'
